import styled from "styled-components";
import { remCalc, media } from "../../../theme/style-utils-coras-nua";
import defaultTheme from "../../../theme/theme-test-override";

const StyledTextArea = styled.textarea`
    resize: vertical;
    width: ${props => (props.fieldWidth ? props.fieldWidth : "100%")};
    ${media.sm.down`
        width: 100%;`}
    box-sizing: border-box;
    -webkit-transition: border 500ms ease-out;
    -moz-transition: border 500ms ease-out;
    -o-transition: border 500ms ease-out;
    transition: border 500ms ease-out;
    -moz-appearance: none;
    -webkit-appearance: none;
    appearance: none;
    border: ${remCalc(1)} solid ${props => props.theme.colors.monotoneMid};
    border-radius: ${props => props.theme.radius};
    height: ${remCalc(60)};
    font-size: ${remCalc(16)};
    background-color: ${props => props.theme.colors.brilliant};
    color: ${props => props.theme.colors.monotoneDark};
    font-family: ${props => props.theme.fonts.fontFamily};
    &::placeholder {
        color: ${props => props.theme.colors.monotoneMidDark};
    }
    &:focus {
        outline: none;
        border-color: ${props => props.theme.colors.primary};
    }
    &[readonly] {
        border-color: ${props => props.theme.colors.backgroundLight};
        cursor: not-allowed;
        &:focus {
            border-color: ${props => props.theme.colors.monotoneMidLight};
        }
    }
    &[disabled] {
        border-color: ${props => props.theme.colors.monotoneMid};
        background: rgba(${props => props.theme.colors.backgroundLight}, 0.3);
        color: ${props => props.theme.colors.monotoneMidDark};
        cursor: not-allowed;
        &:focus {
            border-color: ${props => props.theme.colors.monotoneMid};
        }
    }
    padding: ${remCalc(15)} ${remCalc(15)};
    min-height: ${remCalc(120)};
`;
StyledTextArea.defaultProps = {
    theme: {
        ...defaultTheme
    }
};

export default StyledTextArea;
